import { createStore } from 'satcheljs';
import PremiumStore from './schema/premiumStore';
import { SubscriberType } from './schema/subscriberType';

const premiumStoreData: PremiumStore = {
    domainState: {
        isDomainCreated: false,
        isValid: false,
        domainName: '',
        isRemovingDomain: false,
        isDomainRemoved: false,
        isValidatingDomain: false,
        domainPurchaseDate: null,
    },
    secondarySubscribersInfo: [],
    userInfo: {
        firstName: '',
        lastName: '',
        emailAddress: '',
        prosumerEmailAddress: '',
        isProsumerConsumerMailbox: false,
        isRemovingEmailAddress: false,
        safeLinksEnabled: false,
    },
    subscriberType: SubscriberType.Unknown,
};

const store = createStore<PremiumStore>('premiumStore', premiumStoreData)();
export default store;
